(function () {
  function money(cents, fmt) {
    fmt = fmt || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var t = m ? m[1] : 'amount';
    var v = cents / 100;
    var s = t.indexOf('no_decimals') > -1
      ? Math.round(v).toLocaleString('en-US')
      : v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (t.indexOf('comma') > -1) s = s.replace(/,/g, '_').replace('.', ',').replace(/_/g, '.');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, s);
  }

  function initProduct(root) {
    var jsonEl = root.querySelector('[data-hw-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var form = root.querySelector('[data-hw-form]');
    var idInput = form.querySelector('[name="id"]');
    var atc = form.querySelector('[data-hw-atc]');
    var atcLabel = form.querySelector('[data-hw-atc-label]');
    var totals = root.querySelectorAll('[data-hw-total]');
    var bundles = Array.prototype.slice.call(form.querySelectorAll('[data-hw-bundle]'));
    var bump = form.querySelector('[data-hw-bump]');
    var vbundles = Array.prototype.slice.call(form.querySelectorAll('[data-hw-vbundle]'));
    var optionInputs = form.querySelectorAll('[data-hw-option]');
    var slides = root.querySelectorAll('[data-hw-slide]');
    var thumbs = root.querySelectorAll('[data-hw-thumb]');
    var variant = data.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || data.variants[0];

    function show(i) {
      slides.forEach(function (s) { s.hidden = s.getAttribute('data-hw-slide') !== String(i); });
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-hw-thumb') === String(i)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-hw-thumb')); }); });

    function update(fromOption) {
      if (vbundles.length) {
        var vb = vbundles.filter(function (x) { return x.checked; })[0];
        if (vb) {
          variant = data.variants.filter(function (x) { return String(x.id) === vb.value; })[0] || variant;
          idInput.value = variant.id;
          if (fromOption && variant.featured_media) {
            slides.forEach(function (s) {
              if (s.getAttribute('data-media-id') === String(variant.featured_media.id)) show(s.getAttribute('data-hw-slide'));
            });
          }
        }
      } else if (optionInputs.length) {
        var sel = data.options.map(function (_, i) {
          var c = form.querySelector('[data-hw-option="' + i + '"]:checked');
          return c ? c.value : null;
        });
        var nv = data.variants.filter(function (v) {
          return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; });
        })[0];
        if (nv) variant = nv;
        idInput.value = variant.id;
        root.querySelectorAll('[data-hw-option-label]').forEach(function (el) {
          el.textContent = sel[+el.getAttribute('data-hw-option-label')] || '';
        });
        if (fromOption && variant.featured_media) {
          slides.forEach(function (s) {
            if (s.getAttribute('data-media-id') === String(variant.featured_media.id)) show(s.getAttribute('data-hw-slide'));
          });
        }
      }
      var total = variant.price;
      var unitCompare = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
      bundles.forEach(function (b) {
        var q = +b.value, off = +b.getAttribute('data-off') || 0;
        var now = Math.round(variant.price * q * (100 - off) / 100);
        var cmp = unitCompare * q;
        var opt = b.closest('.hw-opt');
        var n = opt.querySelector('[data-hw-now]'); if (n) n.textContent = money(now, data.money);
        var c = opt.querySelector('[data-hw-cmp]'); if (c) { c.textContent = cmp > now ? money(cmp, data.money) : ''; c.hidden = !(cmp > now); }
        var e = opt.querySelector('[data-hw-each]'); if (e) e.textContent = money(Math.round(now / q), data.money) + ' ' + data.eachLabel;
        if (b.checked) total = now;
      });
      if (bump && bump.checked) total += +bump.getAttribute('data-price');
      totals.forEach(function (el) { el.textContent = money(total, data.money); });
      atc.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? data.addLabel : data.soldLabel;
    }

    form.addEventListener('change', function (e) { update(e.target.hasAttribute('data-hw-option') || e.target.hasAttribute('data-hw-vbundle')); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var b = bundles.filter(function (x) { return x.checked; })[0];
      var q = b ? +b.value : 1;
      var item = { id: variant.id, quantity: q };
      if (b && +b.getAttribute('data-off')) item.properties = { _bundle: b.getAttribute('data-name') };
      var items = [item];
      if (bump && bump.checked) items.push({ id: +bump.value, quantity: 1 });
      atc.disabled = true;
      fetch(data.root.replace(/\/$/, '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j }; });
      }).then(function (res) {
        if (!res.ok) { alert(res.j.description || res.j.message || 'Could not add to cart'); atc.disabled = false; return; }
        location.href = data.after === 'checkout' ? data.root.replace(/\/$/, '') + '/checkout' : data.cartUrl;
      }).catch(function () { atc.disabled = false; form.submit(); });
    });

    var sticky = root.querySelector('[data-hw-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function (en) {
        var vis = en[0].isIntersecting;
        if (vis) seen = true;
        var past = !vis && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', past);
        sticky.setAttribute('aria-hidden', String(!past));
      }).observe(atc);
      sticky.querySelector('[data-hw-sticky-btn]').addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      });
    }
    update(false);
  }

  function boot() { document.querySelectorAll('[data-hw-product]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-hw-product]'); if (r) initProduct(r);
  });
})();
